import { AppState } from 'store';

export const isDownloadingLearnerMatchingMetricsSelector = (state: AppState) =>
  state.learnerMatchingMetricsState.isDownloading;
